<template>
  <div class="patient-labels">
    <Tag
      v-for="(item, index) in labelData?.patientLabels"
      :key="index"
      :color="color(item.labelType)"
      >{{ common.valueToLabel(labelData?.list || [], item.labelId) }}</Tag
    >
    <span v-if="showEditBtn" class="edit-btn" @click="open">
      <Icon type="md-create" />
    </span>
    <setLabels
      v-model="show"
      :info="labelData"
      :patientInfo="info"
      @change="getLabel"
    />
  </div>
</template>

<script>
import request from "@/utils/request.js";
export default {
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
    showEditBtn: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    info: {
      handler() {
        this.getLabel();
      },
    },
  },
  data() {
    return {
      show: false,
      labelData: {},
      typeList: [
        "",
        "magenta",
        "red",
        "volcano",
        "orange",
        "gold",
        "yellow",
        "lime",
        "green",
        "cyan",
        "blue",
        "geekblue",
        "purple",
        "success",
        "error",
        "warning",
      ],
    };
  },
  methods: {
    color(type) {
      return this.typeList[type];
    },
    open() {
      this.show = true;
    },
    getLabel() {
      if (this.info && this.info.patientCode) {
        let obj = {
          patientCode: this.info.patientCode, //	患者编码
        };
        request.post("/saasbaihui/labelData", obj).then((res) => {
          let r = res.result;
          r.list = r.labelTypes.reduce((sum, e) => {
            e.labels.forEach((i) => {
              i.label = i.labelName;
              i.value = i.labelId;
            });
            return sum.concat(e.labels);
          }, []);
          this.labelData = r;
        });
      }
    },
  },
  created() {
    this.getLabel();
  },
};
</script>

<style lang="scss" scoped>
.patient-labels {
  display: inline-block;
  .edit-btn {
    cursor: pointer;
  }
}
</style>